import React from "react";
import { Navigate } from "react-router-dom";
import { DashboardRoutes as dashboardRoutes } from "../pages/Dashboard";
import CategoryRoutes from "../pages/Categories/CategoryRoutes";
import themeExamplesRoutes from "../pages/ThemeComponentsexamples/ThemeExamplesRoutes";
import organizationRoutes from "../pages/Organization/OrganizationRoutes";
import PriorityRoute from "pages/Priority/PriorityRoutes";
import ManagerLevelsViewsRoutes from "../pages/ManagerLevelsViews/ManagerLevelsViewsRoutes";
import CaseClosureApprovalsRoutes from '../pages/CaseClosureApprovals/CaseClosureApprovalsRoutes';
import CaseTransferApprovalsRoutes from '../pages/CaseTransferApprovals/CaseTransferApprovalsRoutes';
import SubCategoryRoutes from "pages/SubCategory/SubCategoryRoutes";
import SocialMediaRoutes from "pages/SocialMedia/SocialMediaRoutes";
import SupportTypeRoutes from "pages/SupportType/SupportTypeRoutes";
import RelationshipRoutes from "pages/Relationship/RelationshipRoutes";
import SuggestDesignationRoutes from "pages/SuggestDesignation/SuggestDesignationRoutes";
import SuggestOrganizationRoutes from "pages/SuggestOrganization/SuggestOrganizationRoutes";
import CaseHandleRoutes from "pages/CaseHandle/CaseHandleRoutes";
import NewCaseHandleRoutes from "pages/CaseHandleNew/NewCaseHandleRoutes";
import NationalCaseRoutes from "pages/CommonInbox/NationalCaseRoutes";
import AllCasesRoutes from "pages/AllCases/AllCasesRoutes";
import ForwardedCasesRoutes from "pages/ForwardCases/ForwardedCasesRoutes";
import EvidenceHistoryRoutes from "pages/EvidenceHistory/EvidenceHistoryRoutes";


import FirstRespondentCaseViewRoutes from "../pages/FirstRespondentCaseView/FirstRespondentCaseViewRoutes";
import FirstRespondentLeadCaseViewRoutes from "../pages/FirstRespondentLeadCaseView/FirstRespondentLeadCaseViewRoutes";
//import DirectorCIDCaseManagementRoutes from "../pages/DirectorCIDCaseManagement/DirectorCIDCaseManagementRoutes";

import QuestionsRoutes from "pages/SubcategoryQuestions/QuestionsRoutes";
import OrgHeadCaseManagementRoutes from "pages/OrgHeadCaseManagement/OrgHeadCaseManagementRoutes";
import TransferredCasesRoutes from "pages/OrgHeadCaseManagement/TransferredCases/TransferredCasesRoutes";
import ForwardCasesRoutes from "pages/OrgHeadCaseManagement/ForwardCases/ForwardCasesRoutes";
import CaseManagerCaseTransferRoutes from "pages/CaseManagerCaseTrasfer/CaseManagerCaseTransferRoutes";
import CaseOfficerCaseManagementRoutes from "pages/CaseOfficerCaseManagement/CaseOfficerCaseManagementRoutes";
import CaseManagerCaseManagementRoutes from "pages/CaseManagerCaseManagement/CaseManagerCaseManagementRoutes";
import OfficerCaseReportingRoutes from "pages/OfficerCaseReporting/OfficerCaseReportingRoutes";
import DataSetupRoutes from "pages/DataSetup/DataSetupRoutes";
import ReportsRoutes from "pages/Reports/ReportsRoutes";
import CallCenterPerformanceRoutes from "pages/CallCenterPerformance/CallCenterPerformanceRoutes";
import OfficerPerformanceRoutes from "pages/OfficerPerformanceDashboard/OfficerPerformanceRoutes";
import PerpetratorInformationRoutes from "../pages/PerpetratorInformation/PerpetratorInformationRoutes";
import InformationSearchViewRoutes from "../pages/InformationSearchView/InformationSearchViewRoutes";
const redirectRoute = [
  {
    path: "/",
    exact: true,
    component: () => <Navigate to="/dashboard" />,
  },
];

const errorRoute = [
  {
    component: () => <Navigate to="/session/404" replace />,
  },
];

const routes = [
  ...redirectRoute,
  ...dashboardRoutes,
  ...PriorityRoute,
  ...ManagerLevelsViewsRoutes,
  ...CaseClosureApprovalsRoutes,
  ...CaseTransferApprovalsRoutes,
  ...themeExamplesRoutes,
  ...SubCategoryRoutes,
  ...CategoryRoutes,
  ...organizationRoutes,
  ...SocialMediaRoutes,
  ...SupportTypeRoutes,
  ...RelationshipRoutes,
  ...SuggestDesignationRoutes,
  ...SuggestOrganizationRoutes,
  ...OrgHeadCaseManagementRoutes,
  ...TransferredCasesRoutes,
  ...CaseHandleRoutes,
  ...NewCaseHandleRoutes,
  ...EvidenceHistoryRoutes,
  ...QuestionsRoutes,
  ...NationalCaseRoutes,
  ...AllCasesRoutes,
  ...ForwardedCasesRoutes,
  ...ForwardCasesRoutes,
  ...CaseManagerCaseTransferRoutes,
  ...CaseOfficerCaseManagementRoutes,
  ...CaseManagerCaseManagementRoutes,
  ...OfficerCaseReportingRoutes,
  ...FirstRespondentCaseViewRoutes,
  ...FirstRespondentLeadCaseViewRoutes,
  ...DataSetupRoutes,
  ...ReportsRoutes,
  ...CallCenterPerformanceRoutes,
  ...PerpetratorInformationRoutes,
  ...InformationSearchViewRoutes,
  ...OfficerPerformanceRoutes,
  ...errorRoute,
  { path: "*", component: () => <Navigate to="/session/404" replace /> },
];

export default routes;
